import $axios from '@/store/axios-instance.js';

export default {
    state: {
        serviceList: null,
        currentService: null,
    },
    mutations: {
        retrieveServiceList(state, payload) {
            state.serviceList = payload
        },
        retrieveService(state, payload) {
            state.currentService = payload
        },
        deleteService(state, payload) {
            if(state.serviceList){
                let entityIndex = state.serviceList.services.findIndex(function (item) {
                    return item.id === payload
                })
                if (entityIndex > -1) {
                    state.serviceList.services.splice(entityIndex, 1)
                }
            }
        },
        addServiceExecutors(state, payload) {
            if (state.currentService) {
                if (!Array.isArray(state.currentService.executors)) {
                    state.currentService.executors = []
                }
                let executor = payload.executorList.find(item => item.id === payload.executorId);
                if (executor) {
                    state.currentService.executors.push(executor)
                }
            }
        },
        deleteServiceExecutor(state, payload) {
            if (state.currentService) {
                if (Array.isArray(state.currentService.executors)) {
                    let entityIndex = state.currentService.executors.findIndex(function (item) {
                        return item.id === payload
                    })
                    if (entityIndex > -1) {
                        state.currentService.executors.splice(entityIndex, 1)
                    }
                }
            }
        },
        servicePushUp(state, payload){
            let oldIndex = state.serviceList.services.findIndex(item => item.id === payload.service.id)
            if(oldIndex > -1) {
                state.serviceList.services.splice(0, 0, state.serviceList.services.splice(oldIndex, 1)[0]);
                Object.assign(state.serviceList.services[0], payload.service);
            } else {
                state.serviceList.services.unshift(payload.service)
                state.serviceList.serviceCount += 1
            }
        },
        openService(state, payload){
            let entity = state.serviceList.services.find(item => item.id === payload)
            entity.isUnread = false
        }
    },
    actions: {
        retrieveServiceList(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .get('services', {
                        params: payload
                    })
                    .then(response => {
                        context.commit('retrieveServiceList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveService(context, payload){
            return new Promise((resolve, reject) => {
                if(!payload){
                    context.commit('retrieveService', null)
                    resolve()
                } else {
                    $axios
                        .get(`services/${payload}`)
                        .then(response => {
                            context.commit('retrieveService', response.data)

                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        createService(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .post(`services`, {
                        id: payload.id,
                        clientId: payload.client.id,
                        departmentId:  payload.department.id,
                        serviceTypeId:  payload.serviceType.id,
                        serviceTypeDescription:  payload.serviceTypeDescription,
                        serviceImportanceId:  payload.serviceImportance.id,
                        description:  payload.description,
                        externalNumber:  payload.externalNumber,
                        executors: payload.executors,
                        chatName: 'KS',
                        isChatIntegrationRequired: false,
                        serviceVisitTypeId: payload.serviceVisitType.id,
                        serviceDate: payload.serviceDate,
                        commentToWorkIds: payload.commentToWorkIds,
                        clientPhone: payload.clientPhone
                    })
                    .then((response) => {
                        context.commit('retrieveService', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        storeService(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .put(`services`, {
                        id: payload.id,
                        clientId: payload.client.id,
                        departmentId:  payload.department.id,
                        serviceTypeId:  payload.serviceType.id,
                        serviceTypeDescription:  payload.serviceTypeDescription,
                        serviceImportanceId:  payload.serviceImportance.id,
                        description:  payload.description,
                        externalNumber:  payload.externalNumber,
                        serviceVisitTypeId: payload.serviceVisitType.id,
                        serviceDate: payload.serviceDate,
                        clientPhone: payload.clientPhone,
                        solution: payload.solution
                    })
                    .then((response) => {
                        context.commit('retrieveService', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        deleteService(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .delete(`services/${payload}`)
                    .then(() => {
                        context.commit('deleteService', payload)
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        addServiceExecutors(context, payload) {
            return new Promise((resolve, reject) => {
                let executorList = context.getters.executorDictionaryList
                payload.executorList.forEach(executor => {
                    $axios
                        .post(`services/${payload.serviceId}/executors`, {
                            executorId: executor
                        })
                        .then(() => {

                            context.commit('addServiceExecutors', {
                                executorId: executor,
                                executorList: executorList
                            })
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                })
                resolve()
            })
        },
        deleteServiceExecutor(context, payload) {
            return new Promise((resolve, reject) => {
                    $axios
                        .delete(`services/${payload.serviceId}/executors/${payload.executorId}`, {
                            executorId: payload.executorId
                        })
                        .then(() => {
                            context.commit('deleteServiceExecutor', payload.executorId)
                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })

            })
        },
        changeServiceStatus(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .put(`services`, {
                        id: payload.serviceId,
                        serviceStatusId: payload.statusId
                    })
                    .then(() => {
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })

            })
        },
        servicePushUp(context, payload){
            context.commit('servicePushUp', payload)
        },
        openService(context, payload){
            return new Promise((resolve) => {
                context.commit('openService', payload)
                context.commit('removeServiceChangedMessage', payload)
                resolve()
            })
        },
    },
    getters: {
        serviceList(state){
            return state.serviceList ? state.serviceList.services : []
        },
        serviceListTotal(state){
            return state.serviceList ? state.serviceList.serviceCount : 0
        },
        currentService(state){
            return state.currentService
        },

    }
}